import history from '../history';

export function redirectTo(url) {
    history.push(url);
}

export function openPageNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
}